import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "reactstrap";
import {
  getTradesbySymbolList,
  setOpenModalTradeData,
} from "../../../Store/Reducer/report.slice";
import { getValansList } from "../../../Store/Reducer/valan.slice";
import { formatUiDateTime } from "utils/dateFormats";

function ModalSummaryUser() {
  const dispatch = useDispatch();

  const { OpenModalTradeData, tradesbySymbolList, openTradeData } =
    useSelector(({ report }) => report);
  const { valansList } = useSelector(({ valan }) => valan);

  const [valanSelected, setValanSelected] = useState(null);

  useEffect(() => {
    if (OpenModalTradeData && (!valansList || valansList.length === 0)) {
      dispatch(getValansList());
    }
  }, [OpenModalTradeData, valansList, dispatch]);

  useEffect(() => {
    if (valansList && valansList.length > 0) {
      const activeValan = valansList.find((item) => item.status);
      if (activeValan) setValanSelected(activeValan);
    }
  }, [valansList]);

  useEffect(() => {
    if (OpenModalTradeData && valanSelected) {
      const filter = {
        userId    : openTradeData?.userId,
        segmentId : openTradeData?.segmentId,
        symbol    : openTradeData?.symbol,
        closeId   : openTradeData?.srNo,
        startDate : valanSelected?.startDate,
        endDate   : valanSelected?.endDate,
      };
      dispatch(getTradesbySymbolList({ data: filter, appendData: false }));
    }
  }, [OpenModalTradeData, valanSelected, dispatch, openTradeData]);

  const columns = useMemo(
    () => [
      { header: "Device",     key: "deviceTypeName" },
      { header: "Segment",    key: "segment"        },
      { header: "Script",     key: "script"         },
      { header: "Type",       key: "typeOrder"      },
      { header: "Trade From", key: "tradeFrom"      },
      { header: "LOT",        key: "lot"            },
      { header: "Quantity",   key: "quantity"       },
      { header: "Rate",       key: "rate"           },
      { header: "Net Rate",   key: "netRate"        },
      { header: "Add Time",   key: "addTime"        },
    ],
    []
  );

  const renderDevice = (row) => {
    if (row.tradeOptionName === "M2MCL")
      return <i className="material-icons minimize_icon">call_to_action</i>;
    if (row.deviceTypeName === "web" || row.deviceType === 1)
      return <i className="material-icons-outlined">public</i>;
    if (row.deviceType === 3)
      return <i className="fa-brands fa-apple" />;
    return <i className="material-icons-outlined">phone_iphone</i>;
  };

  return (
    <Modal
      className="modal-dialog-centered"
      size="xl"
      isOpen={OpenModalTradeData}
    >
      <div className="modal-header">
        <h1 className="modal-title">Information Position</h1>
        <button
          className="close"
          type="button"
          onClick={() => dispatch(setOpenModalTradeData(false))}
        >
          <i className="material-icons-outlined">close</i>
        </button>
      </div>

      <div className="modal-body p-0">
        <div className="table-responsive">
          <table className="table table-sm table-flush table-bordered card_bold mb-0">
            <thead className="thead-light">
              <tr>
                {columns.map((col) => (
                  <th key={col.key} className="text-center">
                    {col.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tradesbySymbolList && tradesbySymbolList.length > 0 ? (
                tradesbySymbolList.map((row, idx) => (
                  <tr key={idx}>
                    <td className="text-center">{renderDevice(row)}</td>
                    <td>{row.segment}</td>
                    <td>{row.script}</td>
                    <td>{row.typeOrder}</td>
                    <td>{row.tradeFrom}</td>
                    <td className="text-right">{row.lot}</td>
                    <td className="text-right">{row.quantity}</td>
                    <td className="text-right">
                      {row.rate != null ? Number(row.rate).toFixed(2) : "-"}
                    </td>
                    <td className="text-right">
                      {row.netRate != null
                        ? Number(row.netRate).toFixed(2)
                        : "-"}
                    </td>
                    <td>{formatUiDateTime(row.addTime, "-")}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center text-danger py-3">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(ModalSummaryUser);
